import { render, staticRenderFns } from "./LockButton.vue?vue&type=template&id=c6c52e4a"
import script from "./LockButton.vue?vue&type=script&lang=js"
export * from "./LockButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports